import React from "react";
import PublicRoute from "./PublicRoute";
import PrivateRoute from "./PrivateRoute";
import Loadable from "react-loadable";
import Loader from "../components/loader";
import authorization from "../utility/authorization.js";

const roleId = authorization.getAuthRoleId();
const userId = authorization.getAuthUserId();

/**
 * Constants for page title and description
 */
export const siteTitle = "Taxida";
export const siteMetaDescription =
  "Taxida offers a hassle-free, reliable and affordable taxi cab service to travel within city or outstation across India.";

/**
 * Function is to set Title for each page
 * @param {*} title
 */
export const setTitle = (title) => {
  document.title = title ? title : siteTitle;
};

/**
 * Function is to set page description
 * @param {*} description
 */
export const setMetaDescription = (description) => {
  document
    .querySelector('meta[name="description"]')
    .setAttribute("content", description ? description : siteMetaDescription);
};

/**
 * List of routes for the page
 */
export const ROUTE = {
  public: [
    {
      exact: true,
      path: "/",
      meta: {},
      name: "Home", // for breadcrumbs
      component: Loadable({
        loader: () => import("../containers/login"),
        loading: Loader,
      }),
    },
    {
      exact: true,
      path: "/login",
      meta: {},
      component: Loadable({
        loader: () => import("../containers/login"),
        loading: Loader,
      }),
    },
    // {
    //   exact: true,
    //   path: "/privacypolicy",
    //   meta: {},
    //   name: "Privacy policy",
    //   component: Loadable({
    //     loader: () => import("../containers/PrivacyPolicy"),
    //     loading: Loader,
    //   }),
    // },
    {
      exact: true,
      path: "/terms",
      meta: {},
      name: "Terms and Conditions",
      component: Loadable({
        loader: () => import("../containers/TermsAndConditions"),
        loading: Loader,
      }),
    },
  ],
  private: [
    {
      exact: true,
      path: "/booking/add",
      meta: {},
      name: "Booking",
      component: Loadable({
        loader: () => import("../containers/tmcBooking"),
        loading: Loader,
      }),
    },
    {
      exact: true,
      path: "/booking/add/:id",
      meta: {},
      name: "Booking",
      component: Loadable({
        loader: () => import("../containers/tmcBooking/editBooking"),
        loading: Loader,
      }),
    },
    {
      exact: true,
      path: "/booking/ets/add/:id",
      meta: {},
      name: "Booking",
      component: Loadable({
        loader: () => import("../containers/tmcBooking/EtsBooking.jsx"),
        loading: Loader,
      }),
    },

    {
      exact: true,
      path: "/booking/b2c/add/:id",
      meta: {},
      name: "Booking",
      component: Loadable({
        loader: () => import("../containers/tmcBooking/B2cBooking.jsx"),
        loading: Loader,
      }),
    },

    {
      exact: true,
      path: "/dashboard",
      meta: {},
      name: "Dashboard",
      component: Loadable({
        loader: () => import("../containers/Dashboard"),
        loading: Loader,
      }),
    },
    {
      exact: true,
      path: "/booking/New",
      meta: {},
      name: "Booking",
      component: Loadable({
        loader: () => import("../containers/tmcBooking/NewBooking"),
        loading: Loader,
      }),
    },
    {
      exact: true,
      path: "/profile",
      meta: {},
      name: "Profile",
      component: Loadable({
        loader: () => import("../containers/profile"),
        loading: Loader,
      }),
    },
    {
      exact: true,
      path: "/report",
      meta: {},
      name: "Reports",
      component: Loadable({
        loader: () => import("../containers/reports/index.jsx"),
        loading: Loader,
      }),
    },
    {
      exact: true,
      path: "/driver/New",
      meta: {},
      name: "Driver",
      component: Loadable({
        loader: () => import("../containers/Driver/newDriver"),
        loading: Loader,
      }),
    },
    {
      exact: true,
      path: "/vehicle/New",
      meta: {},
      name: "Vehicle",
      component: Loadable({
        loader: () => import("../containers/vehicles/newVehicle"),
        loading: Loader,
      }),
    },

    // {
    //   exact: true,
    //   path: "/booking/add/:id",
    //   meta: {},
    //   name: "Booking",
    //   component: Loadable({
    //     loader: () => import("../containers/bookings/index"),
    //     loading: Loader,
    //   }),
    // },
    {
      exact: true,
      path: "/booking-list",
      meta: {},
      name: "Pending",
      component: Loadable({
        loader: () => import("../containers/tripList"),
        loading: Loader,
      }),
    },

    roleId !== 23 &&
    userId !== 1608 &&
    userId !== 1612 &&
    userId !== 1613 &&
    userId !== 191931618
      ? {
          exact: true,
          path: "/operatingArea-pricing/:id",

          meta: {},
          name: "Pending",
          component: Loadable({
            loader: () =>
              import("../containers/OperatingArea/OperatingAreaList.jsx"),
            loading: Loader,
          }),
        }
      : {
          exact: true,
          path: "/",
          meta: {},
          name: "Pending",
          component: Loadable({
            loader: () =>
              import("../containers/OperatingArea/OperatingAreaList.jsx"),
            loading: Loader,
          }),
        },

    {
      exact: true,
      path: "/reports",
      meta: {},
      name: "Complete",
      component: Loadable({
        loader: () => import("../containers/reports/Completed"),
        loading: Loader,
      }),
    },
    {
      exact: true,
      path: "/reports/shuttle",
      meta: {},
      name: "Active",
      component: Loadable({
        loader: () => import("../containers/reports/active"),
        loading: Loader,
      }),
    },
    // {
    //   exact: true,
    //   path: "/triplist/view/:id",
    //   meta: {},
    //   name: "Inprogress",
    //   component: Loadable({
    //     loader: () => import("../containers/triplistDetail/CorpDetails"),
    //     loading: Loader,
    //   }),
    // },
    {
      exact: true,
      path: "/bookinlist/view/:id",
      meta: {},
      name: "Ets details",
      component: Loadable({
        loader: () => import("../containers/tmcBooking/editBooking"),
        loading: Loader,
      }),
    },
    {
      exact: true,
      path: "/user",
      meta: {},
      name: "Agent",
      component: Loadable({
        loader: () => import("../containers/agent"),
        loading: Loader,
      }),
    },
    {
      exact: true,
      path: "/user/add",
      meta: {},
      name: "Add agent",
      component: Loadable({
        loader: () => import("../containers/agent/addAgent"),
        loading: Loader,
      }),
    },
    {
      exact: true,
      path: "/user/:id",
      meta: {},
      name: "Add agent",
      component: Loadable({
        loader: () => import("../containers/agent/addAgent"),
        loading: Loader,
      }),
    },
    {
      exact: true,
      path: "/pricing",
      meta: {},
      name: "Pricing",
      component: Loadable({
        loader: () =>
          import("../containers/OperatingArea/OperatingAreaList.jsx"),
        loading: Loader,
      }),
    },
    {
      exact: true,
      path: "/companies",
      meta: {},
      name: "Companies",
      component: Loadable({
        loader: () => import("../containers/companies"),
        loading: Loader,
      }),
    },
    roleId !== 23
      ? {
          exact: true,
          path: "/associates",
          meta: {},
          name: "Associates",
          component: Loadable({
            loader: () => import("../containers/Associates/associatesList"),
            loading: Loader,
          }),
        }
      : {
          exact: true,
          path: "/",
          meta: {},
          name: "Associates",
          component: Loadable({
            loader: () => import("../containers/Associates/associatesList"),
            loading: Loader,
          }),
        },

    {
      exact: true,
      path: "/drivers",
      meta: {},
      name: "Drivers",
      component: Loadable({
        loader: () => import("../containers/Driver"),
        loading: Loader,
      }),
    },
    {
      exact: true,
      path: "/Vehicle",
      meta: {},
      name: "Vehicle",
      component: Loadable({
        loader: () => import("../containers/vehicles"),
        loading: Loader,
      }),
    },
    // {
    //   exact: true,
    //   path: "/operatingArea",
    //   meta: {},
    //   name: "OperatingArea",
    //   component: Loadable({
    //     loader: () => import("../containers/OperatingArea/operatingArea.jsx"),
    //     loading: Loader,
    //   }),
    // },

    {
      exact: true,
      path: "/companies/add",
      meta: {},
      name: "Add Companies",
      component: Loadable({
        loader: () => import("../containers/companies/addCompany"),
        loading: Loader,
      }),
    },
    {
      exact: true,
      path: "/companies/:id",
      meta: {},
      name: "Edit Companies",
      component: Loadable({
        loader: () => import("../containers/companies/editCompany"),
        loading: Loader,
      }),
    },
    {
      exact: true,
      path: "/branches",
      meta: {},
      name: "Branches",
      component: Loadable({
        loader: () => import("../containers/branch"),
        loading: Loader,
      }),
    },
    {
      exact: true,
      path: "/branches/add",
      meta: {},
      name: "Add Branches",
      component: Loadable({
        loader: () => import("../containers/branch/addBranch"),
        loading: Loader,
      }),
    },
    {
      exact: true,
      path: "/branches/:id",
      meta: {},
      name: "Add Branches",
      component: Loadable({
        loader: () => import("../containers/branch/addBranch"),
        loading: Loader,
      }),
    },
    // {
    //   exact: true,
    //   path: "/tripsheet/shuttle",
    //   meta: {},
    //   name: "Tripsheet",
    //   component: Loadable({
    //     loader: () => import("../containers/tripSheet"),
    //     loading: Loader,
    //   }),
    // },
    {
      exact: true,
      path: "/tripsheet",
      meta: {},
      name: "Tripsheet",
      component: Loadable({
        loader: () => import("../containers/tripSheet/general"),
        loading: Loader,
      }),
    },
    // {
    //   exact: true,
    //   path: "/api-document",
    //   meta: {},
    //   name: "Api document",
    //   component: Loadable({
    //     loader: () => import("../containers/apiDocument"),
    //     loading: Loader
    //   })
    // },
    // {
    //   exact: true,
    //   path: "/api-document/detail/:id",
    //   meta: {},
    //   name: "Api document detail",
    //   component: Loadable({
    //     loader: () => import("../containers/apiDocument/ApiDetail"),
    //     loading: Loader
    //   })
    // },
    {
      exact: true,
      path: "/under-construction",
      meta: {},
      name: "Under construction",
      component: Loadable({
        loader: () => import("../containers/UnderConstruction"),
        loading: Loader,
      }),
    },
    {
      path: "*",
      exact: false,
      meta: {},
      name: "Page Not Found",
      component: Loadable({
        loader: () => import("../containers/pageNotFound/index"),
        loading: Loader,
      }),
    },
  ],
};

/**
 * Function to set route info
 * @param {routeName} routeName
 */
export const setRoutes = (routeName) => {
  routeName = routeName || "public";
  const route = ROUTE[routeName];
  return route.map((eachRoute, index) => {
    if (routeName === "private") {
      return <PrivateRoute key={index} {...eachRoute} />;
    } else {
      return <PublicRoute key={index} {...eachRoute} />;
    }
  });
};
